import {
    AI_NOTE_STREAM_DONE,
    AI_NOTE_STREAM_ERROR,
    GENERATE_AI_SESSION_NOTE_SUCCESS,
    RESET_AI_SESSION_NOTE,
} from './aiNote.type';

/**
 * `streamStatus` lifecycle:
 *   'idle'      → no generation running (initial / after reset)
 *   'streaming' → HTTP succeeded, conversationId issued, chunks may be flowing
 *   'done'      → ai:done received
 *   'error'     → ai:error received
 *
 * The HTTP-loading window (before `streamStatus` flips to 'streaming') is
 * tracked separately via `FindLoad('GENERATE_AI_SESSION_NOTE')`. Consumers
 * that want a single "AI is busy" boolean should OR the two together.
 */
const initialState = {
    /** `{ conversationId }` from POST response, or null. */
    sessionNote: null,
    streamStatus: 'idle',
};

export const aiNoteReducer = (state = initialState, action) => {
    switch (action.type) {
        case GENERATE_AI_SESSION_NOTE_SUCCESS:
            return { ...state, sessionNote: action.payload, streamStatus: 'streaming' };
        case AI_NOTE_STREAM_DONE:
            return { ...state, streamStatus: 'done' };
        case AI_NOTE_STREAM_ERROR:
            return { ...state, streamStatus: 'error' };
        case RESET_AI_SESSION_NOTE:
            return initialState;
        default:
            return state;
    }
};
